import {Button, Text} from "@nike/eds";
import {SizedModal} from "../shared/layout/SizedModal";
import {CopyToClipboard} from "react-copy-to-clipboard";

export const DownloadModal = ({
  downloadModalOpen,
  setDownloadModalOpen,
  content,
  jsonContent,
}) => {
  return !downloadModalOpen ? (
    <div></div>
  ) : (
    <>
      <SizedModal
        isOpen={downloadModalOpen}
        onDismiss={() => setDownloadModalOpen(false)}
        headerSlot={
          <Text font="title-3">
            Payload
          </Text>
        }
        footerSlot={
          <div
            style={{
              display: "grid",
              gridGap: "10px",
              gridTemplateColumns: "auto auto",
              justifyContent: "start",
            }}
          >
            <CopyToClipboard text={content}>
              <Button size="small" className="eds--dark">
                Copy to clipboard
              </Button>
            </CopyToClipboard>
          </div>
        }
      >
        <Text
          font={"body-3"}
          style={{ marginTop: "var(--eds-space-16)" }}
        >
          <pre hidden={!jsonContent}>{content}</pre>

          <div hidden={jsonContent}>{content}</div>
        </Text>
      </SizedModal>
    </>
  );
};
